// Testing and development routes module

export default [
    {
        name: 'websocket-test',
        path: '/_test/websockets',
        component: () => import('@/pages/_test/Websockets.vue'),
        meta: {
            title: 'Websocket Test',
        },
    },

    {
        name: 'queue-test',
        path: '/_test/queue',
        component: () => import('@/pages/_test/Queue.vue'),
        meta: {
            title: 'Queue Test',
        },
    },

    {
        name: 'email-test',
        path: '/_test/email',
        component: () => import('@/pages/_test/Email.vue'),
        meta: {
            title: 'Email Test',
        },
    },

    {
        name: 'error-handling-test',
        path: '/_test/error-handling',
        component: () => import('@/pages/_test/ErrorHandling.vue'),
        meta: {
            title: 'Error Handling Test',
        },
    },
];
